// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { base_environment } from "./environment.base";
import { custom_environment as custom_environment_prod } from "../app/custom/environment.prod";
import { custom_environment } from "../app/custom/environment";

/** core environment used to extend by custom*/
const core_environment = {
  /** System runs in production mode */
  production: false,

  /** Debug */
  debug: {
    remoteDebugging: false,
    remoteDebuggingUrl: "http://universal.app:1337",
    /** Mobile device write log to file, with mobileUseConsoleLogToo it can setted to tose the consol to (good for debugging with chrome browse) */
    mobileUseConsoleLogToo: true,
  },

  /** Log */
  log: {
    /** error = 0, info (+error) = 1, debug (+error +info) = 2 */
    level: 2,
    optIn: true,
    optInLevel: 3,
  },
};

/** Properties of the environment */
export const environment = {
  ...base_environment,
  ...core_environment,
  ...custom_environment_prod,
  ...custom_environment,
};

/** Alias for environment */
export const env = environment;
